import { useReducer } from 'react'

const StateStore = (initial = {}) => useReducer(
  (state, payload) => ({ ...state, ...payload }),
  initial ?? {}
)

export default StateStore